import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { ApiError, rememberInitData } from './lib/api';
import { I18nProvider } from './lib/i18n';
import { initTelegram } from './lib/telegram';
import { ThemeProvider } from './lib/theme';
import { DemoProvider } from './lib/demo';

// Мост до Telegram поднимаем до первого рендера: от него зависят и тема,
// и возможность авторизоваться.
const bridge = initTelegram();
rememberInitData(bridge.initDataRaw);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      // Мини-апп постоянно сворачивают и разворачивают: при возврате
      // данные должны быть свежими, а не из прошлой жизни.
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Нет смысла повторять то, что сервер уже отверг осмысленно.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: { retry: false },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Не найден контейнер #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <DemoProvider>
          <I18nProvider>
            <App bridge={bridge} />
          </I18nProvider>
        </DemoProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
